<template>
  <div class="input-wrapper">
    <label class="input-label">
      <input
        class="search-input search-input--main"
        type="text"
        v-bind="$attrs"
        v-on="inputListeners"
        ref="input"
        :value="value"
      />
      <span v-if="!value">{{ placeholder }}</span>
    </label>
  </div>
</template>

<script>
// TODO: move this component into common-components/
export default {
  props: {
    value: String,
    placeholder: {
      type: String,
      default: 'Find...',
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  computed: {
    inputListeners: function() {
      return {
        ...this.$listeners,
        change: (event) => {
          this.$emit('change', event.target.value);
        },
        input: async (event) => {
          this.$emit('change', event.target.value);
          this.$emit('input', event.target.value);
        },
      };
    },
  },
};
</script>

<style scoped>
.input-wrapper {
  position: relative;
}
.input-label > span {
  position: absolute;
  top: 50%;
  left: 40px;
  transform: translateY(-50%);

  font-style: italic;
  font-weight: normal;
  font-size: 17.2549px;
  line-height: 118.14%;
  /* or 20px */

  letter-spacing: -0.005em;

  color: rgba(7, 29, 59, 0.46);
}
.search-input {
  border: 0px;
  box-sizing: border-box;
  border-radius: 8px;
  /* TODO: move this icon into global.css and make it css var as all other icons */
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 11L15 15' stroke='%23071D3B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='6.5' cy='6.5' r='5.5' stroke='%23071D3B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  height: 43.8px;
  line-height: 43.8px;
  padding-left: 40px;
  background-size: 15px;
  background-position: 15px center;

  font-style: normal;
  font-weight: normal;
  font-size: 17.2549px;

  letter-spacing: -0.005em;

  color: #333;
  box-shadow: var(--dropshadowSmall);

  font-size: var(--tSize-md);
  border-radius: var(--radiusSmall);

  display: inline-block;
  box-sizing: border-box;
  transition: 0.3s ease padding;
}

.search-input:focus + span {
  pointer-events: none;
  opacity: 0;
}
.search-input.search-input--main {
  border-radius: 4px;
}
</style>
